module.exports = __webpack_public_path__ + "static/kartchen-raumnutzung-offentlich2-a8123f31f15de7a9e63eca7535c85f43.png";